export default {
  firebase: {
    'auth/popup-blocked':
      'ポップアップがブロックされました。ブラウザの設定をご確認ください。',
    'auth/network-request-failed':
      'ネットワークエラーが発生しました。通信環境をご確認ください。',
    'auth/too-many-requests':
      'ログイン試行の回数が上限を超えました。しばらくしてからもう一度お試しください。',
    'auth/user-disabled': 'このアカウントは無効化されています。',
    'auth/invalid-email': 'メールアドレスの形式が正しくありません。',
    'auth/invalid-credential':
      'メールアドレスまたはパスワードが正しくありません。',
    'auth/wrong-password': 'メールアドレスまたはパスワードが正しくありません。',
    'auth/user-not-found': 'メールアドレスまたはパスワードが正しくありません。',
    'auth/invalid-action-code':
      'ログインリンクが無効または使用済みです。もう一度送信してください。',
    'auth/expired-action-code':
      'ログインリンクの有効期限が切れています。もう一度送信してください。',
    'auth/operation-not-allowed':
      'メールリンクでのログインが有効になっていません。管理者にお問い合わせください。'
  },

  common: {
    home: 'ホーム',
    search: '検索',
    reset: 'リセット',
    add: '新規追加',
    edit: '編集',
    detail: '詳細',
    view: '表示',
    preview: 'プレビュー',
    replace: '差し替え',
    delete: '削除',
    saveChanges: '変更を保存',
    stop: '停止',
    activate: '有効化',
    csvExport: 'CSV出力',
    percent: '{{value}}%',
    all: 'すべて',
    empty: 'データがありません',
    inputPlaceholder: '入力してください',
    selectPlaceholder: '選択してください',
    account: 'アカウント',
    logout: 'ログアウト',
    back: '戻る',
    cancel: 'キャンセル',
    retry: '再試行',
    rules: {
      required: '必須項目です',
      email: 'メールアドレスの形式が正しくありません',
      password: '8文字以上で入力してください',
      length: '{{length}}桁で入力してください',
      number: '半角数字で入力してください',
      rate: '小数点第2位までの半角数字で入力してください',
      rateRange: '{{min}}〜{{max}}の範囲で入力してください'
    },
    totalCount: '全 {{count}} 件',
    copyright: '© 2026 Linktivity inc. All Rights Reserved.'
  },

  goodType: {
    other: 'その他',
    confectionery: '菓子類',
    alcohol: '酒類',
    freshProduce: '生鮮農産物',
    foodBeverage: '食料品・飲料（たばこを除く）',
    cosmeticsPerfume: '化粧品・香水',
    medicines: '医薬品',
    healthGoodsToiletries: '健康グッズ・トイレタリー',
    clothing: '衣類',
    shoesBagsLeatherGoods: '靴・かばん・革製品',
    electronics: '電気製品（デジタルカメラ/PC/家電等）',
    watchesFilmCameras: '時計・フィルムカメラ',
    jewelryPreciousMetals: '宝石・貴金属',
    folkCraftsTraditionalCrafts: '民芸品・伝統工芸品',
    booksMagazinesGuidebooks: '本・雑誌・ガイドブックなど',
    musicVideoGamesSoftware: '音楽・映像・ゲームなどソフトウェア',
    tobacco: 'たばこ'
  },

  gender: {
    male: '男性',
    female: '女性'
  },
  permitType: {
    temporaryVisitor: '短期滞在',
    diplomat: '外交',
    official: '公用',
    portLanding: '寄港地上陸',
    shipTourism: '船舶観光上陸',
    transitLanding: '通過上陸',
    crewLanding: '乗員上陸',
    emergencyLanding: '緊急上陸',
    distressLanding: '遭難上陸',
    sofa: '日米地位協定該当者',
    overseasResident: '国外居住者'
  },

  permitDocumentType: {
    landingSticker: '上陸許可シール',
    landingPermit: '上陸許可書',
    kosekiFukuhyo: '戸籍附票',
    residenceCertificate: '海外在留証明',
    mynumberCard: 'マイナンバーカード',
    landingStamp: '上陸許可印'
  },
  refundMethod: {
    credit: 'クレジットカード',
    union: '銀聯カード',
    alipay: 'Alipay',
    wechatpay: 'WeChat Pay',
    cash: '現金'
  },

  nationality: {
    AFG: 'アフガニスタン',
    ALB: 'アルバニア',
    DZA: 'アルジェリア',
    AND: 'アンドラ',
    AGO: 'アンゴラ',
    ATG: 'アンティグア・バーブーダ',
    ARG: 'アルゼンチン',
    ARM: 'アルメニア',
    AUS: 'オーストラリア',
    AUT: 'オーストリア',
    AZE: 'アゼルバイジャン',
    BHS: 'バハマ',
    BHR: 'バーレーン',
    BGD: 'バングラデシュ',
    BRB: 'バルバドス',
    BLR: 'ベラルーシ',
    BEL: 'ベルギー',
    BLZ: 'ベリーズ',
    BEN: 'ベナン',
    BTN: 'ブータン',
    BOL: 'ボリビア',
    BIH: 'ボスニア・ヘルツェゴビナ',
    BWA: 'ボツワナ',
    BRA: 'ブラジル',
    BRN: 'ブルネイ',
    BGR: 'ブルガリア',
    BFA: 'ブルキナファソ',
    BDI: 'ブルンジ',
    CPV: 'カーボベルデ',
    KHM: 'カンボジア',
    CMR: 'カメルーン',
    CAN: 'カナダ',
    CAF: '中央アフリカ共和国',
    TCD: 'チャド',
    CHL: 'チリ',
    CHN: '中国',
    COL: 'コロンビア',
    COM: 'コモロ',
    COD: 'コンゴ民主共和国',
    COG: 'コンゴ共和国',
    CRI: 'コスタリカ',
    CIV: 'コートジボワール',
    HRV: 'クロアチア',
    CUB: 'キューバ',
    CYP: 'キプロス',
    CZE: 'チェコ',
    DNK: 'デンマーク',
    DJI: 'ジブチ',
    DMA: 'ドミニカ国',
    DOM: 'ドミニカ共和国',
    ECU: 'エクアドル',
    EGY: 'エジプト',
    SLV: 'エルサルバドル',
    GNQ: '赤道ギニア',
    ERI: 'エリトリア',
    EST: 'エストニア',
    SWZ: 'エスワティニ',
    ETH: 'エチオピア',
    FJI: 'フィジー',
    FIN: 'フィンランド',
    FRA: 'フランス',
    GAB: 'ガボン',
    GMB: 'ガンビア',
    GEO: 'ジョージア',
    DEU: 'ドイツ',
    GHA: 'ガーナ',
    GRC: 'ギリシャ',
    GRD: 'グレナダ',
    GTM: 'グアテマラ',
    GIN: 'ギニア',
    GNB: 'ギニアビサウ',
    GUY: 'ガイアナ',
    HTI: 'ハイチ',
    HND: 'ホンジュラス',
    HUN: 'ハンガリー',
    ISL: 'アイスランド',
    IND: 'インド',
    IDN: 'インドネシア',
    IRN: 'イラン',
    IRQ: 'イラク',
    IRL: 'アイルランド',
    ISR: 'イスラエル',
    ITA: 'イタリア',
    JAM: 'ジャマイカ',
    JPN: '日本',
    JOR: 'ヨルダン',
    KAZ: 'カザフスタン',
    KEN: 'ケニア',
    KIR: 'キリバス',
    PRK: '北朝鮮',
    KOR: '韓国',
    KWT: 'クウェート',
    KGZ: 'キルギス',
    LAO: 'ラオス',
    LVA: 'ラトビア',
    LBN: 'レバノン',
    LSO: 'レソト',
    LBR: 'リベリア',
    LBY: 'リビア',
    LIE: 'リヒテンシュタイン',
    LTU: 'リトアニア',
    LUX: 'ルクセンブルク',
    MDG: 'マダガスカル',
    MWI: 'マラウイ',
    MYS: 'マレーシア',
    MDV: 'モルディブ',
    MLI: 'マリ',
    MLT: 'マルタ',
    MHL: 'マーシャル諸島',
    MRT: 'モーリタニア',
    MUS: 'モーリシャス',
    MEX: 'メキシコ',
    FSM: 'ミクロネシア連邦',
    MDA: 'モルドバ',
    MCO: 'モナコ',
    MNG: 'モンゴル',
    MNE: 'モンテネグロ',
    MAR: 'モロッコ',
    MOZ: 'モザンビーク',
    MMR: 'ミャンマー',
    NAM: 'ナミビア',
    NRU: 'ナウル',
    NPL: 'ネパール',
    NLD: 'オランダ',
    NZL: 'ニュージーランド',
    NIC: 'ニカラグア',
    NER: 'ニジェール',
    NGA: 'ナイジェリア',
    MKD: '北マケドニア',
    NOR: 'ノルウェー',
    OMN: 'オマーン',
    PAK: 'パキスタン',
    PLW: 'パラオ',
    PAN: 'パナマ',
    PNG: 'パプアニューギニア',
    PRY: 'パラグアイ',
    PER: 'ペルー',
    PHL: 'フィリピン',
    POL: 'ポーランド',
    PRT: 'ポルトガル',
    QAT: 'カタール',
    ROU: 'ルーマニア',
    RUS: 'ロシア',
    RWA: 'ルワンダ',
    KNA: 'セントクリストファー・ネーヴィス',
    LCA: 'セントルシア',
    VCT: 'セントビンセント及びグレナディーン諸島',
    WSM: 'サモア',
    SMR: 'サンマリノ',
    STP: 'サントメ・プリンシペ',
    SAU: 'サウジアラビア',
    SEN: 'セネガル',
    SRB: 'セルビア',
    SYC: 'セーシェル',
    SLE: 'シエラレオネ',
    SGP: 'シンガポール',
    SVK: 'スロバキア',
    SVN: 'スロベニア',
    SLB: 'ソロモン諸島',
    SOM: 'ソマリア',
    ZAF: '南アフリカ',
    SSD: '南スーダン',
    ESP: 'スペイン',
    LKA: 'スリランカ',
    SDN: 'スーダン',
    SUR: 'スリナム',
    SWE: 'スウェーデン',
    CHE: 'スイス',
    SYR: 'シリア',
    TWN: '台湾',
    TJK: 'タジキスタン',
    TZA: 'タンザニア',
    THA: 'タイ',
    TLS: '東ティモール',
    TGO: 'トーゴ',
    TON: 'トンガ',
    TTO: 'トリニダード・トバゴ',
    TUN: 'チュニジア',
    TUR: 'トルコ',
    TKM: 'トルクメニスタン',
    TUV: 'ツバル',
    UGA: 'ウガンダ',
    UKR: 'ウクライナ',
    ARE: 'アラブ首長国連邦',
    GBR: 'イギリス',
    USA: '米国',
    URY: 'ウルグアイ',
    UZB: 'ウズベキスタン',
    VUT: 'バヌアツ',
    VEN: 'ベネズエラ',
    VNM: 'ベトナム',
    YEM: 'イエメン',
    ZMB: 'ザンビア',
    ZWE: 'ジンバブエ',
    ABW: 'アルバ',
    AIA: 'アンギラ',
    ALA: 'オーランド諸島',
    ASM: '米領サモア',
    ATA: '南極',
    ATF: '仏領南方・南極地域',
    BES: 'ボネール、シント・ユースタティウス及びサバ',
    BLM: 'サン・バルテルミー',
    BMU: 'バミューダ',
    BVT: 'ブーベ島',
    CCK: 'ココス（キーリング）諸島',
    COK: 'クック諸島',
    CUW: 'キュラソー',
    CXR: 'クリスマス島',
    CYM: 'ケイマン諸島',
    ESH: '西サハラ',
    FLK: 'フォークランド諸島',
    FRO: 'フェロー諸島',
    GBD: '英国（海外領土市民）',
    GBN: '英国（海外国民）',
    GBO: '英国（海外市民）',
    GBP: '英国（保護民）',
    GBS: '英国（臣民）',
    GGY: 'ガーンジー',
    GIB: 'ジブラルタル',
    GLP: 'グアドループ',
    GRL: 'グリーンランド',
    GUF: '仏領ギアナ',
    GUM: 'グアム',
    HKG: '香港',
    HMD: 'ハード島・マクドナルド諸島',
    IMN: 'マン島',
    IOT: '英領インド洋地域',
    JEY: 'ジャージー',
    MAC: 'マカオ',
    MAF: 'サン・マルタン（仏領）',
    MNP: '北マリアナ諸島',
    MSR: 'モントセラト',
    MTQ: 'マルティニーク',
    MYT: 'マヨット',
    NCL: 'ニューカレドニア',
    NFK: 'ノーフォーク島',
    NIU: 'ニウエ',
    PCN: 'ピトケアン',
    PRI: 'プエルトリコ',
    PSE: 'パレスチナ',
    PYF: '仏領ポリネシア',
    REU: 'レユニオン',
    RKS: 'コソボ',
    SGS: 'サウスジョージア・サウスサンドウィッチ諸島',
    SHN: 'セントヘレナ・アセンション及びトリスタンダクーニャ',
    SJM: 'スヴァールバル諸島及びヤンマイエン島',
    SPM: 'サンピエール島・ミクロン島',
    SXM: 'シント・マールテン（蘭領）',
    TCA: 'タークス・カイコス諸島',
    TKL: 'トケラウ',
    UMI: '合衆国領有小離島',
    VAT: 'バチカン',
    VGB: '英領ヴァージン諸島',
    VIR: '米領ヴァージン諸島',
    WLF: 'ウォリス・フツナ',
    XXA: '無国籍',
    XXB: '難民（難民条約）',
    XXC: '難民（その他）',
    XXX: '国籍不明'
  },
  views: {
    dashboard: {
      title: 'ダッシュボード',
      filter: {
        merchant: '企業選択',
        allMerchants: '全企業',
        shop: '店舗選択',
        allShops: '全店舗',
        dateRange: '日付範囲',
        datePlaceholder: 'yyyy-mm-dd'
      },
      stats: {
        count: '免税件数',
        sales: '対象売上 (税込)',
        tax: '税額'
      },
      chart: {
        title: '免税件数',
        legend: '件数'
      },
      ratio: {
        title: '売上割合',
        others: 'その他'
      },
      loadFailed: 'ダッシュボードの取得に失敗しました'
    },
    login: {
      title: '管理者ログイン',
      googleLogin: 'Googleでログイン',
      emailLogin: 'メールアドレスでログイン',
      email: 'メールアドレス',
      submit: 'ログイン',
      sendLink: 'ログインリンク',
      resendLink: 'ログインリンク',
      linkSent:
        '{{email}} にログインリンクを送信しました。メール内のリンクからログインしてください。',
      checkEmail:
        'ログインリンクを送信しました。メールを確認し、リンクからログインしてください',
      confirmEmail:
        '確認のため、ログインリンクを受け取ったメールアドレスを入力してください。',
      accountNotFound: 'このアカウントは登録されていません',
      serverError: 'ログインに失敗しました。しばらくしてから再度お試しください',
      unsupportedRole: 'このアカウントでは管理画面をご利用いただけません'
    },
    merchants: {
      title: '企業管理',
      add: '新規企業追加',
      listTitle: '企業一覧',
      stats: {
        total: '総企業数',
        active: '有効',
        inactive: '停止'
      },
      filter: {
        merchantName: '企業名',
        merchantNamePlaceholder: '企業名を入力'
      },
      columns: {
        merchantName: '企業名',
        merchantId: '企業ID',
        createdDate: '作成日',
        status: 'ステータス',
        actions: '操作'
      },
      status: {
        active: '有効',
        inactive: '停止'
      },
      loadFailed: '企業一覧の取得に失敗しました'
    },
    shops: {
      title: '店舗管理',
      listTitle: '店舗一覧',
      register: '店舗を登録',
      categories: '商品カテゴリ設定',
      loadFailed: '店舗一覧の取得に失敗しました',
      filter: {
        keyword: 'キーワード検索',
        keywordPlaceholder: '店舗名·店舗ID'
      },
      columns: {
        shopName: '店舗名',
        shopId: '店舗ID',
        ntaShopId: '販売場識別符号',
        status: '状態',
        actions: '操作'
      },
      status: {
        active: '有効',
        inactive: '停止'
      }
    },
    shopCategories: {
      title: '商品カテゴリ設定',
      badge: '既定',
      save: '変更を保存',
      updated: '変更を保存しました',
      updateFailed: '変更の保存に失敗しました',
      loadFailed: '店舗情報の取得に失敗しました',
      basic: {
        title: '店舗基本情報',
        shopName: '店舗名',
        shopId: '店舗ID',
        ntaShopId: '販売場識別符号'
      },
      supported: {
        title: '取り扱いカテゴリ',
        note: '複数選択可，選択中: <count>{{selected}} / {{total}}</count> カテゴリ'
      },
      default: {
        title: 'カテゴリ一覧',
        label: '既定カテゴリ',
        placeholder: 'カテゴリを選択',
        hint: '免税申請時に最初に選択された状態になるカテゴリです。左側のカテゴリから選択してください。'
      }
    },
    shopForm: {
      createTitle: '新規店舗追加',
      editTitle: '店舗編集',
      register: '登録',
      save: '変更を保存',
      created: '店舗を登録しました',
      createFailed: '店舗の登録に失敗しました',
      updated: '変更を保存しました',
      updateFailed: '変更の保存に失敗しました',
      loadFailed: '店舗情報の取得に失敗しました',
      stop: 'この店舗を停止',
      stopped: '店舗を閉店しました',
      stopFailed: '店舗の閉店に失敗しました',
      stopConfirm: {
        title: '閉店しますか？',
        description: '閉店後は取り消すことができません。',
        confirm: '閉店する'
      },
      stoppedNotice: 'この店舗は閉店しています。ボタンから再開できます。',
      reopen: '店舗を再開',
      reopened: '店舗を再開しました',
      reopenFailed: '店舗の再開に失敗しました',
      reopenConfirm: {
        title: '店舗を再開しますか？',
        confirm: '再開'
      },
      basic: {
        title: '店舗登録情報',
        shopId: '店舗ID',
        shopIdHint: 'ログインIDは変更できません',
        shopName: '店舗名'
      },
      device: {
        title: '店舗設備·認証情報',
        merchantId: '企業ID',
        loginId: '店舗ID',
        password: 'パスワード',
        passwordHint: '8文字以上·英数字記号を含む'
      },
      nta: {
        title: '免税店販売場情報',
        shopName: '販売場名称',
        shopCode: '販売場識別符号',
        shopCodeHint: '税務署から通知された識別符号。変更時は届出が必要です',
        shopPlace: '販売場所在地',
        shopType: '販売場区分',
        regiType: '免税モード',
        kioskMode: 'キオスクモード'
      },
      regiType: {
        busicom: 'ビジコム',
        smaregi: 'スマレジ',
        sharp: 'SHARP',
        ocr: 'OCR',
        none: 'なし'
      },
      kiosk: {
        enabled: 'あり',
        disabled: 'なし'
      },
      shopType: {
        noProxy: '代理なし',
        proxy: '承認免税手続事業者に代理',
        vendingMachine: '自動販売機型'
      },
      smaregi: {
        title: 'スマレジ情報',
        contractId: 'Contract ID',
        storeId: 'Store ID',
        storePlaceholder: '店舗を選択',
        fetchStores: '店舗取得',
        fetchStoresFailed: '店舗の取得に失敗しました'
      },
      busicom: {
        title: 'ビジコム情報'
      },
      sharp: {
        title: 'SHARP情報'
      },
      ocr: {
        title: 'OCR情報',
        prompt: 'Prompt'
      },
      terminal: {
        title: 'Terminal',
        terminalId: '端末ID',
        terminalName: '端末名',
        add: '端末を追加'
      }
    },
    merchantForm: {
      createTitle: '新規企業追加',
      editTitle: '企業編集',
      register: '登録',
      save: '変更を保存',
      created: '企業を登録しました',
      createFailed: '企業の登録に失敗しました',
      updated: '変更を保存しました',
      updateFailed: '変更の保存に失敗しました',
      loadFailed: '企業情報の取得に失敗しました',
      stop: 'この企業を停止',
      stopped: '企業を停止しました',
      stopFailed: '企業の停止に失敗しました',
      stopConfirm: {
        title: '企業を停止しますか？',
        description: '停止すると、この企業はログインできなくなります。',
        confirm: '停止する'
      },
      stoppedNotice: 'この企業は停止しています。ボタンから再開できます。',
      reopen: '企業を再開',
      reopened: '企業を再開しました',
      reopenFailed: '企業の再開に失敗しました',
      reopenConfirm: {
        title: '企業を再開しますか？',
        confirm: '再開'
      },
      system: {
        title: 'システム設定',
        note: '本項目はLinktivityにより設定されています。変更をご希望の場合は、サポート部門へお問い合わせください。',
        merchantId: '企業ID',
        systemCharge: 'アカウント管理費用',
        wechatRate: '免税手数料率（WeChat Pay）',
        alipayRate: '免税手数料率（Alipay）',
        creditRate: '免税手数料率（クレジットカード）',
        unionRate: '免税手数料率（Union Pay）',
        cashRate: '免税手数料率（現金還付）',
        rateValue: '{{value}}%',
        chargeValue: '{{value}}/月'
      },
      basic: {
        title: '基本情報',
        merchantId: '企業ID',
        merchantIdHint: 'ログインIDは変更できません',
        companyName: '企業名（法人名）',
        agent: '代理店名',
        agentPlaceholder: '代理店を選択',
        agentCommissionRate: '代理店手数料率 (%)',
        representativeName: '法人代表者名',
        representativeNameKana: '法人代表者名（フリガナ）',
        representativeTitle: '法人代表者役職名'
      },
      contact: {
        title: '本部担当者情報',
        department: '本部担当者部署名',
        contactName: '本部担当者名',
        postalCode: '本部担当郵便番号',
        address: '本部担当住所',
        phone: '本部電話番号',
        contactEmail: '本部担当者メールアドレス'
      },
      nta: {
        title: '販売場情報',
        bizName: '事業者氏名·名称',
        bizPlace: '事業者納税地',
        taxOffice: '所轄税務署'
      },
      fee: {
        title: '課金·手数料設定',
        wechatRate: '免税手数料率（WeChat Pay）(%)',
        alipayRate: '免税手数料率（Alipay）(%)',
        creditRate: '免税手数料率（クレジットカード）(%)',
        unionRate: '免税手数料率（Union Pay）(%)',
        cashRate: '免税手数料率（現金還付）(%)',
        refundFeeRateHint: '免税額に対する手数料率',
        commissionRate: '店舗手数料率 (%)',
        commissionRateHint: '免税額に対する手数料率',
        systemCharge: 'アカウント管理費用',
        systemChargeHint: '日額固定費'
      }
    },
    documents: {
      title: '免税書類',
      listTitle: '免税書類の統計',
      filter: {
        merchant: '企業選択',
        allMerchants: '全企業',
        shop: '店舗選択',
        allShops: '全店舗',
        documentNumber: '書類番号検索',
        documentNumberPlaceholder: '書類番号',
        orderStatus: '注文状態',
        dateRange: '日付範囲',
        datePlaceholder: 'yyyy-mm-dd'
      },
      columns: {
        documentNumber: '書類番号',
        merchantName: '企業名',
        shopName: '店舗名',
        purchasedAt: '日時',
        totalAmount: '総額',
        refundAmount: '還付税額',
        orderStatus: '注文状態',
        actions: '操作'
      },
      orderStatus: {
        unsent: '未送信',
        unapplied: '未申請',
        processing: '還付中',
        completed: '還付済',
        cancelled: 'キャンセル',
        failed: '還付失敗'
      },
      manualSend: '手動送信',
      loadFailed: '免税書類一覧の取得に失敗しました',
      sent: '送信が完了しました。',
      sendFailed: {
        title: '送信失敗',
        description: '送信に失敗しました。再試行してください。'
      },
      csv: {
        title: 'CSV出力',
        dateRange: '日付範囲',
        hint: '購入日の範囲を選択してください（最大{{days}}日間）。',
        dateRequired: '開始日と終了日を選択してください',
        rangeExceeded: '日付範囲は最大{{days}}日以内で選択してください',
        confirm: '出力する',
        exportFailed: 'CSV出力に失敗しました'
      }
    },
    documentDetail: {
      title: '免税書類詳細',
      loadFailed: '免税書類の取得に失敗しました',
      stop: '書類停止',
      stopped: '書類を停止しました',
      stopFailed: '書類の停止に失敗しました',
      stopConfirm: {
        title: '書類を停止しますか？',
        description:
          '国税庁への購入記録送信を取り消します。税関で出国確認済みの書類は停止できません。',
        confirm: '停止する'
      },
      summary: {
        totalAmount: '総額',
        taxAmount: '税額',
        refundFee: '手数料総額',
        starpayCommission: '手数料(NetStar)',
        profit: '手数料(Linktivity)',
        merchantCommission: '手数料(店舗)',
        agentCommission: '手数料(代理)',
        refundAmount: '還付額',
        refundMethod: '還付方法'
      },
      basic: {
        title: '基本情報',
        documentNumber: '書類番号',
        merchantName: '企業名',
        shopName: '店舗名',
        purchasedAt: '日時'
      },
      timeline: {
        title: '処理タイムライン',
        sent: '送信完了',
        applied: '申請受付完了',
        customs: '税関出境確認完了',
        customsPending: '税関出境確認中',
        customsFailed: '税関審査未通過',
        refund: '還付処理',
        refundPending: '返金処理中',
        refundSuccess: '返金完了',
        refundFailed: '返金失敗'
      },
      customerNotice:
        '「購入者情報、アップロード書類」の編集は、<customer>「顧客情報」</customer>から行ってください。',
      passport: {
        title: '購入者情報',
        name: '姓名',
        nationality: '国籍',
        nationalityValue: '{{code}} | {{name}}',
        dateOfBirth: '生年月日',
        passportNumber: 'パスポート番号',
        dateOfExpiry: '有効期限',
        entryDate: '入国日',
        purchasedAt: '購入日',
        permitType: '在留資格',
        permitExpiry: '在留期限'
      },
      files: {
        title: 'アップロード書類',
        passport: 'パスポート',
        permit: '上陸許可書類',
        empty: 'アップロードされた書類はありません'
      },
      receipts: {
        title: 'レシート',
        name: 'レシート {{index}}',
        empty: 'レシートはありません'
      },
      goods: {
        title: '購入明細',
        total: '合計',
        columns: {
          name: '商品',
          amount: '税込価格',
          taxAmount: '還付税額',
          quantity: '数量',
          subtotal: '小計',
          actions: '操作'
        }
      },
      edit: {
        title: '購入明細編集',
        name: '商品',
        amount: '税込価格 (¥)',
        taxAmount: '税額 (¥)',
        quantity: '数量',
        subtotal: '小計 (¥)',
        confirm: '変更を確認',
        updated: '購入明細を更新しました',
        updateFailed: '購入明細の更新に失敗しました'
      }
    },
    customers: {
      title: '顧客情報',
      listTitle: '顧客情報一覧',
      filter: {
        keyword: 'キーワード検索',
        keywordPlaceholder: 'パスポート番号または書類番号を入力'
      },
      columns: {
        familyName: '姓',
        givenName: '名',
        nationality: '国籍',
        passportNumber: 'パスポート番号',
        actions: '操作'
      },
      loadFailed: '顧客情報一覧の取得に失敗しました'
    },
    customerDetail: {
      title: '顧客詳細',
      loadFailed: '顧客情報の取得に失敗しました',
      meta: {
        total: '送信書類数 {{count}}',
        editable: '編集可能 {{count}}',
        locked: 'ロック済み {{count}}'
      },
      passport: {
        title: 'パスポート情報',
        note: '変更内容は、このパスポートに紐づく未出国の記録にのみ反映されます。出国済みの記録は申告時点のスナップショットが保持され、変更の影響を受けません。',
        familyName: '姓',
        givenName: '名',
        gender: '性別',
        nationality: '国籍',
        nationalityValue: '{{code}} | {{name}}',
        dateOfBirth: '生年月日',
        passportNumber: 'パスポート番号',
        dateOfExpiry: 'パスポート有効期限',
        saved: 'パスポート情報を更新しました',
        saveFailed: 'パスポート情報の更新に失敗しました'
      },
      documents: {
        title: '送信書類の関連付け',
        note: '通関済みの注文は読み取り専用のスナップショットとして表示され、未通関の注文はビザ情報の直接編集およびファイルの追加・削除が可能です。',
        cleared: '通関済み',
        pending: '未通関',
        failed: 'NTA送信失敗',
        purchasedAt: '購入日: {{value}}',
        clearedAt: '通関確認日時: {{value}}',
        clearedNotice:
          '税関での出国確認が完了しているため、ビザ情報およびファイルは読み取り専用です。',
        failedNotice:
          'NTA への申告結果が確定しているため、ビザ情報およびファイルは読み取り専用です。',
        permitType: '在留資格',
        permitExpiry: '在留期限',
        entryDate: '入国日',
        files: 'アップロード書類',
        file: '在留資格を証明する書類',
        filesEmpty: 'アップロードされた書類はありません',
        upload: 'アップロード',
        uploadHint: 'JPG or PNG',
        uploadFailed: '書類のアップロードに失敗しました',
        uploadUnsupported: 'JPG または PNG の画像を選択してください',
        expand: '展開する',
        collapse: '折りたたむ',
        empty: '送信書類はありません',
        saved: '送信書類の関連付けを更新しました',
        saveFailed: '送信書類の関連付けの更新に失敗しました',
        saveRejected: '次の書類は更新できませんでした: {{ids}}'
      }
    },
    notifications: {
      title: '通知センター',
      listTitle: '通知一覧',
      loadFailed: '通知一覧の取得に失敗しました',
      stats: {
        pending: '処理待ち',
        handled: '処理済み',
        total: '全件数'
      },
      filter: {
        merchant: '企業選択',
        allMerchants: '全企業',
        shop: '店舗選択',
        allShops: '全店舗',
        documentNumber: '書類番号検索',
        documentNumberPlaceholder: '書類番号'
      },
      columns: {
        occurredAt: '日時',
        shopId: '店舗ID',
        documentNumber: '書類番号',
        errorCode: 'エラーコード',
        status: '処理状況',
        actions: '操作'
      },
      status: {
        pending: '処理待ち',
        finished: '処理完了',
        disregarded: '対応不要'
      },
      detail: {
        title: '通知詳細内容',
        rawLabel: '受信結果通知の原文',
        remark: '処理備考',
        dismiss: '対応不要にする',
        finish: '処理済みにする',
        finishFailed: '更新に失敗しました',
        dismissFailed: '更新に失敗しました'
      }
    },

    agencies: {
      title: '代理店管理',
      listTitle: '代理店一覧',
      register: '代理店登録',
      filter: {
        keyword: 'キーワード検索',
        keywordPlaceholder: '代理店名·代理店ID'
      },
      columns: {
        agencyId: '代理店ID',
        agencyName: '代理店名',
        status: '状態',
        actions: '操作'
      },
      status: {
        active: '有効',
        inactive: '停止'
      },
      loadFailed: '代理店一覧の取得に失敗しました',
      created: '代理店を登録しました',
      createFailed: '代理店の登録に失敗しました',
      stopped: '代理店を停止しました',
      stopFailed: '代理店の停止に失敗しました',
      stopConfirm: {
        title: '代理店を停止しますか？',
        description: '停止すると、この代理店はログインできなくなります。',
        confirm: '停止する'
      },
      activated: '代理店を有効化しました',
      activateFailed: '代理店の有効化に失敗しました',
      activateConfirm: {
        title: '代理店を有効化しますか？',
        confirm: '有効化する'
      },
      form: {
        title: '代理店登録',
        agencyId: '代理店ID',
        agencyName: '代理店名',
        confirm: '登録確認'
      }
    },

    staffs: {
      title: 'スタッフ管理',
      listTitle: 'スタッフ統計',
      register: 'スタッフ追加',
      stop: '無効化',
      activate: '有効化',
      filter: {
        keyword: 'キーワード検索',
        keywordPlaceholder: 'スタッフ名 / メールアドレス',
        role: 'ロール',
        merchant: '企業選択',
        shop: '店舗選択'
      },
      columns: {
        name: 'スタッフ名',
        email: 'メールアドレス',
        role: 'ロール',
        merchant: '企業名',
        shop: '店舗名',
        phone: '連絡先 (電話番号)',
        status: '状態',
        actions: '操作'
      },
      roles: {
        linkAdmin: 'Linktivity admin',
        linkCs: 'Linktivity cs',
        merchantAdmin: '企業アドミン',
        merchantStaff: '企業スタッフ',
        shopAdmin: '店舗アドミン',
        shopStaff: '店舗スタッフ'
      },
      status: {
        active: '有効化',
        inactive: '無効化'
      },
      loadFailed: 'スタッフ一覧の取得に失敗しました',
      created: 'スタッフを追加しました',
      createFailed: 'スタッフの追加に失敗しました',
      updated: 'スタッフ情報を更新しました',
      updateFailed: 'スタッフ情報の更新に失敗しました',
      stopped: 'スタッフを無効化しました',
      stopFailed: 'スタッフの無効化に失敗しました',
      stopConfirm: {
        title: 'このスタッフを無効化しますか？',
        description: '無効化すると、このスタッフはログインできなくなります。',
        confirm: '無効化する'
      },
      activated: 'スタッフを有効化しました',
      activateFailed: 'スタッフの有効化に失敗しました',
      activateConfirm: {
        title: 'このスタッフを有効化しますか？',
        confirm: '有効化する'
      },
      form: {
        addTitle: 'スタッフ追加',
        editTitle: 'スタッフ編集',
        name: 'スタッフ名',
        email: 'スタッフメール',
        role: 'ロール',
        merchant: '企業名',
        shop: '店舗名',
        linkMerchant: 'リンクティビティ',
        rootShop: 'ルート',
        phone: '電話番号',
        confirmAdd: '追加を確認',
        confirmEdit: '変更を確認'
      }
    },
    agencyMerchants: {
      title: '代理企業一覧',
      listTitle: '企業一覧',
      loadFailed: '代理企業一覧の取得に失敗しました',
      columns: {
        merchantId: '企業ID',
        merchantName: '企業名',
        commissionRate: '代理店手数料率',
        status: '状態'
      },
      status: {
        active: '有効',
        inactive: '停止'
      }
    },
    accountInfo: {
      merchantTitle: '企業情報',
      shopTitle: '店舗情報',
      loadFailed: 'アカウント情報の取得に失敗しました',
      shops: '店舗管理',
      edit: '企業を編集',
      meta: {
        merchantId: '企業 ID: {{value}}',
        shopId: '店舗ID: {{value}}',
        createdDate: '登録日: {{value}}'
      },
      status: {
        active: '有効',
        inactive: '停止'
      },
      basic: {
        title: '基本情報',
        companyName: '企業名（法人名）：',
        representativeName: '法人代表者名:',
        representativeTitle: '法人代表者役職名:',
        contactName: '本部担当者名:',
        phone: '本部電話番号:',
        contactEmail: '本部担当者メール:'
      },
      system: {
        title: 'システム設定',
        note: 'Linktivity設定項目',
        merchantId: '企業 ID:',
        wechatRate: '免税手数料率（WeChat Pay）:',
        alipayRate: '免税手数料率（Alipay）:',
        creditRate: '免税手数料率（クレジットカード）:',
        unionRate: '免税手数料率（Union Pay）:',
        cashRate: '免税手数料率（現金還付）:',
        systemCharge: 'アカウント管理費用:',
        rateValue: '{{value}}%',
        chargeValue: '{{value}}/月'
      },
      shop: {
        title: '店舗情報',
        shopId: '店舗ID:',
        shopName: '店舗名:'
      },
      nta: {
        title: '販売場情報',
        bizName: '事業者氏名·名称:',
        bizPlace: '事業者納税地:',
        taxOffice: '所轄税務署:'
      }
    }
  }
};
